import React, { useState } from "react";
import { DRAWER_BACKGROUND } from "../../../constants/styles";

export default function AssetDetailsDrawer({ assetOpen, assetCode, setAssetOpen }) {

  const [docsOpen, setDocsOpen] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [inspectionOpen, setInspectionOpen] = useState(false);
  const [hoverEvent, setHoverEvent] = useState(null);

  const OMNI_BLUE = "#5a9bd6";

  const MAIN_WIDTH = 420;
  const SUB_WIDTH = 380;

  const events = [
    { day: 5, type: "service", title: "Routine Service" },
    { day: 14, type: "inspection", title: "Inspection Due" },
    { day: 22, type: "outage", title: "Display Fault" }
  ];

  function getColour(type) {
    if (type === "service") return OMNI_BLUE;
    if (type === "inspection") return "#7dd3fc";
    if (type === "outage") return "#ef4444";
    return "rgba(255,255,255,0.05)";
  }

  function MonthCard({ events }) {
    const days = Array.from({ length: 31 }, function (_, i) { return i + 1; });

    return (
      <div>

        <div style={{ fontWeight: 600, marginBottom: "10px" }}>
          January 2026
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(7,1fr)",
          gap: "6px"
        }}>

          {days.map(function (day) {

            const event = events.find(function (e) { return e.day === day; });

            return (
              <div
                key={day}
                onMouseEnter={function () { if (event) setHoverEvent(event); }}
                onMouseLeave={function () { setHoverEvent(null); }}
                onClick={function () {
                  if (event) {
                    setInspectionOpen(true);
                  }
                }}
                style={{
                  height: "34px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "11px",
                  cursor: event ? "pointer" : "default",
                  background: event ? getColour(event.type) : "rgba(255,255,255,0.04)",
                  color: event ? "#fff" : "#888"
                }}
              >
                {day}
              </div>
            );
          })}

        </div>
      </div>
    );
  }

  return (
    <>

      {/* ================= MAIN DRAWER ================= */}
      <div style={{
        position: "fixed",
        top: "0px",
        right: assetOpen ? "0px" : "-" + MAIN_WIDTH + "px",
        width: MAIN_WIDTH,
        height: "100vh",
        background: DRAWER_BACKGROUND,
        backdropFilter: "blur(10px)",
        boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
        transition: "right 0.4s ease",
        zIndex: 350,
        color: "#fff"
      }}>

        {/* HEADER */}
        <div style={{
          padding: "18px 22px",
          fontWeight: 600,
          borderBottom: "1px solid rgba(255,255,255,0.08)"
        }}>
          Asset Details
          <span style={{ float: "right", cursor: "pointer" }} onClick={() => setAssetOpen(false)}>✕</span>
        </div>

        {/* BODY */}
        <div style={{ padding: "22px", overflowY: "auto" }}>

          <img src="/matterportimages/tv.jpg" style={{
            width: "100%",
            borderRadius: "14px",
            marginBottom: "18px"
          }} />

          <div style={{ fontSize: "22px", fontWeight: 700 }}>
            Samsung Display Monitor
          </div>

          <div style={{ fontSize: "13px", color: "#aaa", marginBottom: "20px" }}>
            Asset Code: {assetCode}
          </div>

          {/* 🔥 RESTORED TABLE */}
          <table style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
            marginBottom: "22px"
          }}>
            <tbody>
              {[
                ["Manufacturer", "Samsung"],
                ["Model", "QB65B Smart Signage"],
                ["Screen Size", "65 inch"],
                ["Resolution", "4K UHD"],
                ["Installed", "12 Feb 2023"],
                ["Maintenance Cycle", "12 Months"]
              ].map(function (row, i) {
                return (
                  <tr key={i}>
                    <td style={{
                      padding: "10px",
                      color: "#888",
                      fontSize: "11px",
                      textTransform: "uppercase",
                      borderBottom: "1px solid rgba(255,255,255,0.05)"
                    }}>
                      {row[0]}
                    </td>
                    <td style={{
                      padding: "10px",
                      fontWeight: 600,
                      borderBottom: "1px solid rgba(255,255,255,0.05)"
                    }}>
                      {row[1]}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* BUTTONS */}
          <button onClick={() => {
            setDocsOpen(true);
            setCalendarOpen(false);
          }} style={{
            width: "100%",
            padding: "14px",
            background: OMNI_BLUE,
            border: "none",
            borderRadius: "10px",
            color: "#fff",
            fontWeight: 600
          }}>
            View Documentation
          </button>

          <button onClick={() => {
            setCalendarOpen(true);
            setDocsOpen(false);
          }} style={{
            width: "100%",
            padding: "14px",
            marginTop: "12px",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "10px",
            color: "#fff"
          }}>
            View Maintenance Schedule
          </button>

        </div>
      </div>

      {/* ================= DOCUMENT DRAWER ================= */}
      <div style={{
        position: "fixed",
        top: "0px",
        right: docsOpen ? MAIN_WIDTH + "px" : "-" + SUB_WIDTH + "px",
        width: SUB_WIDTH,
        height: "100vh",
        background: DRAWER_BACKGROUND,
        backdropFilter: "blur(10px)",
        boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
        transition: "right 0.4s ease",
        zIndex: 340,
        color: "#fff"
      }}>
        <div style={{ padding: "18px 22px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          Documentation
          <span style={{ float: "right", cursor: "pointer" }} onClick={() => setDocsOpen(false)}>✕</span>
        </div>

        <div style={{ padding: "18px" }}>
          {["Installation Guide.pdf", "User Manual.pdf", "Warranty.pdf"].map(function (d, i) {
            return (
              <div key={i} style={{
                padding: "12px 0",
                borderBottom: "1px solid rgba(255,255,255,0.05)",
                cursor: "pointer"
              }}>
                📄 {d}
              </div>
            );
          })}
        </div>
      </div>

      {/* ================= MAINTENANCE DRAWER ================= */}
      <div style={{
        position: "fixed",
        top: "0px",
        right: calendarOpen ? MAIN_WIDTH + "px" : "-" + SUB_WIDTH + "px",
        width: SUB_WIDTH,
        height: "100vh",
        background: DRAWER_BACKGROUND,
        backdropFilter: "blur(10px)",
        boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
        transition: "right 0.4s ease",
        zIndex: 340,
        color: "#fff"
      }}>
        <div style={{ padding: "18px 22px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          Maintenance Schedule
          <span style={{ float: "right", cursor: "pointer" }} onClick={() => setCalendarOpen(false)}>✕</span>
        </div>

        <div style={{ padding: "20px" }}>
          <MonthCard events={events} />
        </div>
      </div>

	  {/* ================= INSPECTION DRAWER ================= */}
	  <div style={{
	    position: "fixed",
	    top: "0px",
	    right: inspectionOpen ? (MAIN_WIDTH + SUB_WIDTH) + "px" : "-420px",
	    width: 420,
	    height: "100vh",
	    background: DRAWER_BACKGROUND,
	    backdropFilter: "blur(10px)",
	    boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
	    transition: "right 0.4s ease",
	    zIndex: 330,
	    color: "#fff"
	  }}>

	    {/* HEADER */}
	    <div style={{
	      padding: "18px 22px",
	      fontWeight: 600,
	      borderBottom: "1px solid rgba(255,255,255,0.08)"
	    }}>
	      Inspection Report
	      <span style={{ float: "right", cursor: "pointer" }} onClick={() => setInspectionOpen(false)}>✕</span>
	    </div>

	    <div style={{ padding: "22px" }}>

	      {/* 🔍 SUMMARY TABLE */}
	      <table style={{
	        width: "100%",
	        borderCollapse: "collapse",
	        fontSize: "13px",
	        marginBottom: "22px"
	      }}>
	        <tbody>

	          {[
	            ["Inspector", "John Smith"],
	            ["Date", "12 Feb 2024"],
	            ["Company", "OmniScan Services Ltd"]
	          ].map(function (row, i) {
	            return (
	              <tr key={i}>
	                <td style={{
	                  padding: "10px",
	                  color: "#888",
	                  fontSize: "11px",
	                  textTransform: "uppercase",
	                  borderBottom: "1px solid rgba(255,255,255,0.05)"
	                }}>
	                  {row[0]}
	                </td>
	                <td style={{
	                  padding: "10px",
	                  fontWeight: 600,
	                  borderBottom: "1px solid rgba(255,255,255,0.05)"
	                }}>
	                  {row[1]}
	                </td>
	              </tr>
	            );
	          })}

	          {/* ⭐ RATING ROW */}
	          <tr>
	            <td style={{
	              padding: "10px",
	              color: "#888",
	              fontSize: "11px",
	              textTransform: "uppercase"
	            }}>
	              Rating
	            </td>
	            <td style={{ padding: "10px" }}>
	              <span style={{
	                padding: "4px 10px",
	                borderRadius: "6px",
	                background: "#16a34a",   // green = good
	                fontWeight: 600,
	                fontSize: "12px"
	              }}>
	                PASS
	              </span>
	            </td>
	          </tr>

	        </tbody>
	      </table>

	      {/* 📝 DESCRIPTION */}
	      <div style={{
	        fontSize: "13px",
	        color: "#bbb",
	        lineHeight: "1.6",
	        marginBottom: "24px"
	      }}>
	        The display unit was inspected under standard operating conditions. 
	        Visual clarity, colour calibration, and brightness levels were all within acceptable tolerances. 
	        Firmware was updated to the latest version and connectivity to the network was verified. 
	        No physical defects or performance degradation were identified during testing.
	      </div>

	      {/* 🔘 BUTTON */}
	      <button style={{
	        width: "100%",
	        padding: "14px",
	        borderRadius: "10px",
	        border: "none",
	        background: OMNI_BLUE,
	        fontWeight: 600,
	        cursor: "pointer",
	        color: "#fff",
	        boxShadow: "0 8px 20px rgba(0,0,0,0.4)"
	      }}>
	        View Full Report
	      </button>

	    </div>

	  </div>

    </>
  );
}